<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-monitoring-attendance-details-by-status"
      title="ATTENDANCE DETAILS BY STATUS"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      scrollable
    >
      <div class="mb-2 mt-1">
        <b-row>
          <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>CODE</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="dataModal.code" disabled />
            </b-input-group>
            <!-- <h5>Code</h5>
            <p
              class="rounded text-primary border-primary font-medium-1 text-center py-1s"
            >
              {{ dataModal.code }}
            </p> -->
          </b-col>
          <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>NAME</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="dataModal.personal_name" disabled />
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div class="table-responsive">
        <b-table
          small
          sticky-header="50vh"
          class="position-relative"
          table-class="text-nowrap"
          :items="items"
          :fields="showFields"
        >
          <template #cell(created_by)="data">
            <span> {{ data.value | capitalize }} </span> <br />
            <span style="opacity: 0.5">
              {{ data.item.created_at | globalDate }}
            </span>
          </template>
          <template #cell(abbreviation)="data">
            <b-badge
              pill
              :variant="`light-${homeworkStatusVariant(
                data.item.homework_status_id
              )}`"
              :class="{ 'cursor-pointer': data.item.to_day != null }"
            >
              <span> {{ data.item.abbreviation }} - {{ data.item.date }}</span>
            </b-badge>
          </template>
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${data.item.status == 0 ? 'danger' : 'success'}`"
            >
              <span> {{ data.item.status == 0 ? "Inactive" : "Active" }} </span>
            </b-badge>
          </template>
          <template #cell(description)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(observation)="data">
            <span> {{ data.value }} </span>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import modalMixin from "@/mixins/modal";
import FieldsModal from "@/views/monitoring/views/attendance/data/fields.moda.data.js";
/* Service */
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";

export default {
  mixins: [modalMixin],
  props: {
    dataModal: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      fields: FieldsModal,
    };
  },
  mounted() {
    this.toggleModal("modal-monitoring-attendance-details-by-status");
  },
  async created() {
    if (this.dataModal.homework_status_id != null) {
      await this.getAttendanceDetailByStatus();
    } else {
      await this.getAttendanceOfToday();
    }
  },
  computed: {
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
  },
  methods: {
    validateFields() {
      const status = this.fields[1];
      if (this.dataModal.homework_status_id != null) {
        status.visible = false;
      } else {
        status.visible = true;
      }
    },
    async getAttendanceDetailByStatus() {
      try {
        this.addPreloader();
        const params = {
          attendance_id: this.dataModal.attendance_id,
          homework_status_id: this.dataModal.homework_status_id,
        };

        const { data } = await AttendanceService.getAttendanceDetailByStatus(
          params
        );
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getAttendanceOfToday() {
      try {
        this.addPreloader();
        const params = {
          attendance_id: this.dataModal.attendance_id,
          date: this.dataModal.today,
        };

        const { data } = await AttendanceService.getAttendanceOfToday(params);
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    homeworkStatusVariant(homework_status_id) {
      if (homework_status_id === 4) return "warning";
      if (homework_status_id === 3) return "danger";
      if (homework_status_id === 1 || homework_status_id === 2)
        return "success";
      if (homework_status_id === "inactive") return "secondary";
      return "primary";
    },
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>